/**
 * 메인 "쇼핑몰 추천" 위젯.
 *
 * 어드민 슬롯 키 `main_shop_card`(있으면) 우선, 없으면 네이버 스마트스토어 카테고리 6개로 폴백.
 * 자체 쇼핑몰 연동 전 임시 운영: 모든 링크는 새 탭으로 외부 스마트스토어 이동.
 *   스토어: https://smartstore.naver.com/carebalance
 */
import { ShoppingBag, ChevronRight } from 'lucide-react'
import PromotionSlot from '@/components/common/PromotionSlot'

const STORE_URL = 'https://smartstore.naver.com/carebalance'

const FALLBACK_ITEMS: { name: string; href: string; emoji: string }[] = [
  { name: '보행보조도구', href: `${STORE_URL}/category/3f1214eb93ad4954bef4590280730e02?cp=1`, emoji: '🦯' },
  { name: '건강측정용품', href: `${STORE_URL}/category/87d44db8260246dcb4cbadcbbeeea4fb?cp=1`, emoji: '🩺' },
  { name: '건강관리용품', href: `${STORE_URL}/category/4b338eb5115b4f32a5fdaca4a29ca268?cp=1`, emoji: '💊' },
  { name: '보호대', href: `${STORE_URL}/category/950d4312936147e3b02ebc66a919ef16?cp=1`, emoji: '🩹' },
  { name: '물리치료·찜질', href: `${STORE_URL}/category/8becb51831734b1188907cd2c3927bae?cp=1`, emoji: '♨️' },
  { name: '생활편의용품', href: `${STORE_URL}/category/6571a272919f4b8c8f7c969a11203bd5?cp=1`, emoji: '🛒' },
]

export default function ShopRecommend() {
  return (
    <section className="rounded-2xl border border-cb-gray-100 bg-white p-5">
      <header className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-1.5 text-base font-bold text-cb-gray-900">
          <ShoppingBag size={16} className="text-cb-primary" />
          요양 쇼핑몰
        </h2>
        <a
          href={STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-0.5 text-xs font-medium text-cb-gray-500 hover:text-cb-primary"
        >
          전체 <ChevronRight size={12} />
        </a>
      </header>

      {/* 어드민이 main_shop_card 슬롯을 운영하면 그걸 노출, 아니면 카테고리 폴백 */}
      <PromotionSlot
        slotKey="main_shop_card"
        limit={4}
        layout="slider"
        fallback={
          <ul className="grid grid-cols-2 gap-2">
            {FALLBACK_ITEMS.map((item) => (
              <li key={item.name}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 rounded-xl bg-cb-gray-50 px-3 py-3 hover:bg-cb-primary-light"
                >
                  <span className="text-lg">{item.emoji}</span>
                  <span className="text-xs font-semibold text-cb-gray-900">
                    {item.name}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        }
      />
    </section>
  )
}
